// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"Newsline_ProseMirror__1gUnp","newsline":"Newsline_newsline__2nZKJ","fade":"Newsline_fade__2nBLL","news":"Newsline_news__wqAFE","popover":"Newsline_popover__3JQ0s"};